/* eslint-disable */
import React, { Component } from 'react';
import NotificationSystem from 'react-notification-system';
import { Checkbox, DateField } from '../../../commons/Inputs';
import appConfig from '../../../../config';
import axios from 'axios';
import moment from 'moment';

let $ = window.jQuery;

export default class DentalHistory extends Component {

	state = {
		checkboxItem : [{name : 'cavities[]',label : 'Bad Breath',id : 'checbox', value: 'bad_breath'},{name : 'cavities[]',label : 'Clicking or Lock Jaw',id : 'checbox', value : 'clicking_popping_jaw'},{name : 'cavities[]',label : 'Grinding teeth',id : 'checbox',value : 'grinding_teeth'},{name : 'cavities[]',label : 'Periodental Treatment',id : 'checbox', value : 'periodental_treatment'},{name : 'cavities[]',label : 'Sensitivity to cold water',id : 'checbox', value : 'sensitive_cold'},
			{name : 'cavities[]',label : 'Sensitivity when biting',id : 'checbox', value : 'sensitive_bite'},{name : 'cavities[]',label : 'Bleeding Gums',id : 'checbox', value : 'bleeding_gums'},{name : 'cavities[]',label : 'Food collection between teeth',id : 'checbox', value : 'food_collect'},
			{name : 'cavities[]',label : 'Loose teeth or broken fillings',id : 'checbox', value : 'loose_teeth'},{name : 'cavities[]',label : 'Sensitivity to hot water',id : 'checbox', value : 'sensitive_hot'},
			{name : 'cavities[]',label : 'Sensitivity to sweet',id : 'checbox', value : 'sensitive_sweet'},{name : 'cavities[]',label : 'Sores or growth in your mouth',id : 'checbox', value : 'sores_in_mouth'},],
		
		previews_dentist : '',
		last_visit : '',
		reason_visit : '',
		chief_complaint : '',
		patientId : 0,
		cavities : [],
		dentalRender : true
	}

	onDatepickerChange = (e) => {

		this.setState({last_visit : e.target.value},
			() => {
				this.onInputField(e);
		})
		
	}

	onInputField = (e) => {

		if($(e.target).val().trim() == '')
		{
			return;
		}

		let formData = $('#dentalHistoryForm').serialize();

			formData += '&patient_id=' + this.state.patientId;

		const url = appConfig.apiUrl + 'dental/dental-histories/' + + this.props.storeParams.patientId;

        axios({
            url: url,
            method: 'post',
            responseType: 'json',
            data : formData,
        }).then((response) => {
            console.log(response)
            this.showSuccessNotification();
            
        }).catch(function (error) {

        });
	}

	getDentalHistory = () => {

		App.blockUI({
            target: 'body',
            boxed: true
        });

		const url = appConfig.apiUrl + 'dental/dental-histories/patient/' + this.props.storeParams.patientId;
		
		axios({
            url: url,
            method: 'get',
            responseType: 'json'
        }).then((response) => {
            // console.log(response.data)
            
            if(response.data.data.length <= 0)
            {
            	this.setState({dentalRender : false});
            }

            let cavitiesArray = response.data.data[0].cavities;
            let cavitiesObject = {};
            $.each(cavitiesArray,(key, value) => {
            	cavitiesObject[value] = value;
            });

            this.setState({
            	previews_dentist : response.data.data[0].previews_dentist,
            	last_visit : response.data.data[0].last_visit != '0000-00-00' ? moment(response.data.data[0].last_visit).format('MMMM D, YYYY') : '',
            	reason_visit : response.data.data[0].reason_visit,
            	chief_complaint : response.data.data[0].chief_complaints,
            	cavities : cavitiesObject,
            	dentalRender : false
            }, () => {
            	// console.log(this.state)
            });
            App.unblockUI('body');
            
        }).catch(function (error) {
			App.unblockUI('body');
        });
	}

	showSuccessNotification = () => {
        // let notificationSystem = this.refs.notificationSystem;
        
        // notificationSystem.addNotification({
        //     title: 'Saved! Successfully',
        //     message: 'Dental history Successfully Saved!',
        //     level: 'success',
        //     position : 'bl',
        //     autoDismiss : 1
        // });
        App.alert({
        	type: 'info',
        	container : $('#alertNotif'),
        	message: 'Saved Succesfully!',
        	reset: true,
        	focus: false,
        	close: false,	
        	closeInSeconds: 1})
    };

	componentWillMount() {
		
		this.setState({patientId : this.props.storeParams.patientId});	
			

	}

	componentDidMount() {
		// this.onDatepickerChange();

		// if(sessionStorage.getItem('lastTab') == 'dentalHistoryPage') // last tab open
		// {
		// 	this.getDentalHistory();
		// }

		$('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {

            let target = e.target.href.split('#');
            let index = target.findIndex((item) => {
                return item === 'dentalHistoryPage'
            });
            
            if (index >= 0 && this.state.dentalRender) {
                this.getDentalHistory();
            }
        });
	}


	render() {
		let cavs = this.state.cavities;
		
		return (
			<form role="form" id="dentalHistoryForm">

			<NotificationSystem ref="notificationSystem" />
				
				<div className="form-group">
					<div className="row">
						<div className="col-md-6">
							<div className="form-group form-md-line-input">
				                <input type="text" placeholder="" name="previews_dentist" className="form-control" value={this.state.previews_dentist} onBlur={this.onInputField} onChange={(e) => { this.setState({previews_dentist : e.target.value}) }}/> 
								<label className="control-label">Previous Dentist</label>
			                </div>
		                </div>
		                <div className="col-md-6">
		                	<DateField val={this.state.last_visit} readonly={true} id="last_visit" label="Last Dental Visit" help="Enter Date" onChange={this.onDatepickerChange} />
		                		
		                </div>
					</div>
				</div>
				<div className="form-group">
					<div className="row">
						<div className="col-md-12">
							<div className="form-group form-md-line-input">
				                <textarea rows="3" name="reason_visit" className="form-control" value={this.state.reason_visit} onBlur={this.onInputField} onChange={(e) => { this.setState({reason_visit : e.target.value}) }} /> 
								<label className="control-label">Reason for last visit</label>
			                </div>
		                </div>
					</div> 
				</div>
				<div className="form-group">
					<div className="row">
						<div className="col-md-12">
							<div className="form-group form-md-line-input">
				                <textarea rows="3" name="chief_complaints" className="form-control" value={this.state.chief_complaint} onBlur={this.onInputField} onChange={(e) => { this.setState({chief_complaint : e.target.value}) }} /> 
								<label className="control-label">Chief Complaint</label>
			                </div>
		                </div>
					</div> 
				</div>
				<div className="form-group form-md-checkboxes">
					<div className="row">
						<div className="col-md-12">
							<label><strong>Do you have any of the following?</strong></label>
						</div>
					</div>
					<div className="row">
						<div className="col-md-6 col-sm-6">
							{this.state.checkboxItem.map((item, i) => {
								if(i < 6)
								{
									return <Checkbox {...item} key={i} index={i} onchange={this.onInputField} checkedItems={cavs} />
								}
							})}
						</div>
						<div className="col-md-6 col-sm-6">
							{this.state.checkboxItem.map((item, i) => {
								if(i > 6)
									return <Checkbox {...item} key={i} index={i} onchange={this.onInputField} checkedItems={cavs} />
							})}
						</div>
					</div>
				</div>
			</form>	
		)
	}

}


/** WEBPACK FOOTER **
 ** ./src/components/patient/Dental_history/DentalHistory.js
 **/